import React, { useState } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";

export default function Login() {
  // const [email, setEmail] = useState("superuser@stg-xenorize.com");
  // const [password, setPassword] = useState("Test123#@!");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { login, isAuthenticated, error } = useAuth();
  const navigate = useNavigate();
  const params = useParams();

  // If already authenticated, redirect to admin dashboard
  if (isAuthenticated) {
    if (params?.origin) {
      navigate(params.origin);
    } else {
      navigate("/admin-v2/users");
      // navigate("/");
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await login(email, password);
    } catch (err) {
      console.log(err.message);
    }

    setIsSubmitting(false);
  };

  return (
    <div
      className="h-screen w-full flex items-center justify-center"
      style={{
        background: "linear-gradient(to bottom left, #413072, #08080B)",
      }}
    >
      <div className="bg-white max-w-md w-full space-y-8 p-6 md:p-8 shadow-[0px_0px_20px_#000a] rounded-2xl max-md:mx-5">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Xenorize Admin Panel
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Sign in to access the admin dashboard
          </p>
        </div>

        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label
                htmlFor="email-address"
                className="!text-left block text-sm mb-1"
              >
                Email address
              </label>
              <input
                id="email-address"
                name="email"
                type="email"
                autoComplete="email"
                required
                className="w-full bg-[#f3f4f8] border-none rounded-[10px] shadow-[0_1.5px_1px_#c1c7cd] text-sm mt-1 mb-2.5 py-[1em] px-[1.25em]"
                // className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="!mt-2">
              <label
                htmlFor="password"
                className="!text-left block text-sm mb-1"
              >
                Password
              </label>

              <div className="relative">
                <input
                  id="password"
                  name="password"
                  type={showPassword ? "text" : "password"}
                  autoComplete="current-password"
                  required
                  className="w-full bg-[#f3f4f8] border-none rounded-[10px] shadow-[0_1.5px_1px_#c1c7cd] text-sm mt-1 mb-2.5 py-[1em] px-[1.25em]"
                  // className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                {showPassword ? (
                  <EyeSlashIcon
                    className="w-[16px] h-[16px] absolute top-[50%] translate-y-[-50%] right-4 cursor-pointer"
                    onClick={() => setShowPassword(!showPassword)}
                  />
                ) : (
                  <EyeIcon
                    className="w-[16px] h-[16px] absolute top-[50%] translate-y-[-50%] right-4 cursor-pointer"
                    onClick={() => setShowPassword(!showPassword)}
                  />
                )}
              </div>
            </div>
          </div>

          {error && (
            <div className="rounded-md bg-red-50 p-4">
              <div className="flex">
                <div className="ml-3">
                  <h3 className="text-sm font-medium text-red-800">{error}</h3>
                </div>
              </div>
            </div>
          )}

          <div>
            <button
              type="submit"
              disabled={isSubmitting}
              // className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              className="w-full relative overflow-hidden py-3 font-bold text-base bg-[#007A78] rounded-lg text-white"
            >
              {isSubmitting ? "Signing in..." : "Sign in"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
